import { StandardProps } from "../componentMap";
import { CreditOfferUI } from "./CreditOfferUI";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { dispatchAnalyticsEvent } from "../../utils";

export function CreditOffer({
  product,
  creditOffers,
  configProps,
}: Pick<StandardProps, "product" | "creditOffers" | "configProps">) {
  const { variant, isSelected } = useVariant(product);
  if (!isSelected) return null;

  const skuOffers = creditOffers?.find(
    ({ skuId }) => skuId === variant.aliases.skuId,
  );
  if (!skuOffers) return null;

  const itemClickHandler = (subtype: string, type = "pdp") => {
    dispatchAnalyticsEvent(
      "global.interaction",
      { type: type, subType: subtype },
      {
        products: [
          {
            brand: product.brand?.name || "",
            category:
              product.browsePageHierarchy[
                product.browsePageHierarchy.length - 1
              ].categoryId, // if available
            sku: variant.aliases.skuId,
            price: variant.price?.value || "",
            productName: variant.title,
            productId: product.aliases.pimProductId,
          },
        ],
      },
    );
  };

  const iBCItemAnalyticsHandler = (subtype: string, type: string) => {
    dispatchAnalyticsEvent(
      "global.interaction",
      { type: type, subType: subtype },
      {
        products: [],
        additionalInfo: {},
        properties: {},
      },
    );
  };

  return (
    <CreditOfferUI
      offers={skuOffers.creditIllustrations}
      ibcDisclaimerAnalyticsClickHandler={iBCItemAnalyticsHandler}
      ifcDisclaimerAnalyticsClickHandler={itemClickHandler}
      hideIfHasIFC={configProps?.hideIfHasIFC as boolean | undefined}
      hideIfNoIFC={configProps?.hideIfNoIFC as boolean | undefined}
    />
  );
}
